import axios from 'axios';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export interface RecordDiagnosisRequestT {
  /**
   * Client-generated UUIDv7 that makes recording idempotent: retrying with the
   * same id returns the existing diagnosis instead of creating a duplicate.
   */
  diagnosisId: string;
  icd10Code: string;
  note: string;
}

export interface RecordDiagnosisResponseT {
  diagnosisId: string;
  icd10Code: string;
}

export async function fetchRecordDiagnosis(
  userId: string,
  request: RecordDiagnosisRequestT,
  signal?: AbortSignal
): Promise<RecordDiagnosisResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.post<RecordDiagnosisResponseT>(
    `/greenfield/care/${userId}/diagnoses`,
    {
      diagnosisId: request.diagnosisId,
      icd10Code: request.icd10Code,
      note: request.note,
    },
    config
  );
  return {
    diagnosisId: response.data.diagnosisId,
    icd10Code: response.data.icd10Code,
  };
}
